//NODE MODULES
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useLazyQuery, gql } from "@apollo/client";
import _ from "lodash";
import { useAtomValue } from "jotai";

//KPP COMPONENTS
import { PageHeader, GridItemLink } from "../components/helpers";
import { NewsItem } from "../components/news";

//STATE
import { previewContentAtom } from "../state/appState";

//GRAPHQL
import { GET_NEWS_ARCHIVED } from "../graphql/news";
const QUERY_LIMIT = 10;

const News = () => {
	const observer = useRef(null);
	const urlParams = useParams();
	const loadMoreTrigger = useRef();

	//Local State
	const [querySkip, setQuerySkip] = useState(0);
	const [showMore, setShowMore] = useState(false);
	const [news, setNews] = useState([]);

	//Atom State
	const isPreviewContent = useAtomValue(previewContentAtom);

	//GraphQL Setup
	const [getNews, { data, errors, loading }] = useLazyQuery(GET_NEWS_ARCHIVED, {
		variables: {
			queryLimit: QUERY_LIMIT,
			querySkip: querySkip,
			isPreview: isPreviewContent,
		},
	});

	useEffect(() => {
		getNews();
	}, []);

	useEffect(() => {
		let newsData = [];
		let orderedNews = [];

		if (data && data.newsCollection) {
			newsData = data.newsCollection.items;
			const newsOrderDate = newsData.map((newsItem) => {
				const newsWithOrderDate = { ...newsItem, orderDate: newsItem.alternativePublishDate || newsItem.sys.publishedAt };
				return newsWithOrderDate;
			});

			// console.log("NEWS ::", newsOrderDate);
			orderedNews = _.orderBy(newsOrderDate, ["orderDate"], ["desc"]);
		}

		if (data && data.newsCollection.items.length < QUERY_LIMIT) {
			setShowMore(false);
			observer?.current?.unobserve(loadMoreTrigger.current);
		} else if (data) {
			setShowMore(true);
		}

		setNews((prevState) => [...prevState, ...orderedNews]);
	}, [data]);

	useEffect(() => {
		let loadMoreTrigger = null;

		if (showMore) {
			//create new instance and pass a callback function
			observer.current = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						const intersecting = entry.isIntersecting;
						if (intersecting) {
							// console.log("Load More...");
							getNews();
							setQuerySkip((prevState) => prevState + QUERY_LIMIT);
						}
					});
				},
				{ rootMargin: "-200px" }
			);

			//Get the trigger element and observe it
			loadMoreTrigger = document.getElementById("loadMore");
			observer.current.observe(loadMoreTrigger);
		}

		//Cleanup function to remove observer
		return () => {
			if (loadMoreTrigger) observer.current.unobserve(loadMoreTrigger);
		};
	}, [showMore]);

	return (
		<>
			<PageHeader />
			<div className="grid-wrapper pageHeader-wrapper aItems-center">
				<div id="pageHeader-title">
					<h1>News Archive</h1>
				</div>
				<div id="pageHeader-desc">
					<p className="text-maxWidth"></p>
				</div>
			</div>
			{/* <div className="grid-wrapper projects-wrapper" style={{ minHeight: "90vh" }}> */}
			<div className="grid-wrapper grid-columns-autoFill projects-wrapper">
				<GridItemLink linkTo="/news" label="View Latest News" icon="bi bi-newspaper" />
				{news.length &&
					news.map((newsItem, idx) => {
						const delay = 200 * (idx / ((querySkip + QUERY_LIMIT) / QUERY_LIMIT) + 1);
						return (
							<NewsItem
								key={`newsItem-${newsItem.sys.id}`}
								id={newsItem.sys.id}
								slug={newsItem.slug}
								title={newsItem.title}
								image={newsItem.heroImage.url}
								date={newsItem.alternativePublishDate ? newsItem.alternativePublishDate : newsItem.sys.publishedAt}
								project={newsItem.project}
								animationDelay={delay}
							/>
						);
					})}
			</div>

			{loading && <div className="loadingSpinner"></div>}
			{showMore && <div id="loadMore" ref={loadMoreTrigger}></div>}
		</>
	);
};

export default News;
